import { useCallback, useState } from "react";

import { Button } from "@icg360/design-system";

import { NotificationsHeaderButton } from "components/notifications/notifications-header-button";
import { MobileAccountMenu } from "components/page-header/mobile-header/mobile-account-menu";
import { MobileMenu } from "components/page-header/mobile-header/mobile-menu";
import { MobileNavMenu } from "components/page-header/mobile-header/mobile-nav-menu";
import { PolicyHeader } from "components/page-header/policy-header";
import { HeaderLogo } from "components/shared/logo-link";
import { useFlags } from "utils";

import styles from "./mobile-header.module.scss";

type MobileHeaderProps = {
  hidePolicyHeader?: boolean;
  tabs?: Record<string, string>[];
  pageTitle: string;
  isPolicyDrawerOpen: boolean;
  onPolicyDrawerOpen: () => void;
  onPolicyDrawerClose: () => void;
};

export const MobileHeader = ({
  hidePolicyHeader,
  tabs,
  pageTitle,
  isPolicyDrawerOpen,
  onPolicyDrawerOpen,
  onPolicyDrawerClose,
}: MobileHeaderProps) => {
  const { notificationPilot } = useFlags();
  const [mobileMenuState, setMobileMenuState] = useState<
    "closed" | "nav" | "account"
  >("closed");
  const closeMenu = useCallback(() => setMobileMenuState("closed"), []);

  return (
    <>
      <div className={styles.headerContainer}>
        <div className={styles.headerLeft}>
          {mobileMenuState === "nav" ? (
            <Button
              className={styles.headerButtonDS}
              onPress={() => setMobileMenuState("closed")}
              icon="Close"
              data-testid="mobile-nav-close-btn"
            />
          ) : null}
          {mobileMenuState !== "nav" ? (
            <Button
              onPress={() => {
                setMobileMenuState("nav");
              }}
              className={styles.headerButtonDS}
              icon="Menu"
              data-testid="mobile-nav-btn"
            />
          ) : null}
        </div>
        <HeaderLogo logo="mobileInverse" />
        <div className={styles.headerRight}>
          {mobileMenuState === "account" ? (
            <Button
              onPress={() => setMobileMenuState("closed")}
              icon="Close"
              className={styles.headerButtonDS}
              data-testid="mobile-account-close-btn"
            />
          ) : null}
          {mobileMenuState !== "account" ? (
            <Button
              onPress={() => {
                setMobileMenuState("account");
              }}
              icon="User"
              className={styles.headerButtonDS}
              data-testid="mobile-account-btn"
            />
          ) : null}
          {!!notificationPilot && (
            <NotificationsHeaderButton
              buttonClassName={styles.headerButtonDS}
              testId="mobile-notifications-btn"
            />
          )}
        </div>
      </div>
      {!hidePolicyHeader ? (
        <PolicyHeader
          tabs={tabs}
          pageTitle={pageTitle}
          isPolicyDrawerOpen={isPolicyDrawerOpen}
          onPolicyDrawerOpen={onPolicyDrawerOpen}
          onPolicyDrawerClose={onPolicyDrawerClose}
        />
      ) : null}
      {mobileMenuState === "nav" ? (
        <MobileMenu onClose={closeMenu}>
          <MobileNavMenu onClose={() => setMobileMenuState("closed")} />
        </MobileMenu>
      ) : null}
      {mobileMenuState === "account" ? (
        <MobileMenu onClose={closeMenu} align="right">
          <MobileAccountMenu onClose={() => setMobileMenuState("closed")} />
        </MobileMenu>
      ) : null}
    </>
  );
};
